import React from 'react';
import FaQuestionCircle from 'react-icons/lib/fa/question-circle';
import { history } from '../store';
import uk from '../images/uk.png';
import us from '../images/us.png';
import eu from '../images/eu.png';
import jp from '../images/jp.png';

export const LandingView = () => {
    return (
        <div className="home-page">
            <div className="container page pd-1">
                <div className="row landing-page-header">
                    <div className="help-icon text-purple small" title='Click to view Calculations details'>
                        <FaQuestionCircle />
                        <a onClick={() => { history.push('./Help') }}>Help</a>
                    </div>
                </div>
                <br />
                <br />
                <div className="row fontsize text-center">The RealisedRate.com website provides compounded realised rates for key RFR benchmarks using data published by the relevant administrators such as the Bank of England,
                       the Federal Reserve Bank of New York and the European Central Bank.
                <br />
                <br />
                Click on links below to see compounded in arrears rates for the different benchmarks, 
                    or click Help for more information on how the rates are calculated. 
                </div>
                <br />
                <br />
                <div className='extra-margin-top'></div>

                <div className="row text-center">                                   
                </div>                
                <div className="row">
                    <div className="col-sm-12">
                        <div className="col-sm-3 col-xs-12  justify-content-center benchmarkContainer" onClick={() => { history.push('./SONIA') }}>
                            <img src={uk} className="benchmarkIcon" width="25px" height="25px" />
                            <h5 className="card-title ml-1 riskHeading">SONIA</h5>

                        </div>
                        <div className="col-sm-3 col-xs-12  justify-content-center benchmarkContainer" onClick={() => { history.push('./SOFR') }}>
                            <img src={us} className="benchmarkIcon" width="25px" height="25px" />
                            <h5 className="card-title ml-1 riskHeading">SOFR</h5>
                        </div>
                        <div className="col-sm-3 col-xs-12  justify-content-center benchmarkContainer" onClick={() => { history.push('./ESTR') }}>
                            <img src={eu} className="benchmarkIcon" width="25px" height="25px" />
                            <h5 className="card-title ml-1 riskHeading">€STR</h5>
                        </div>

                        <div className="col-sm-3 col-xs-12  justify-content-center benchmarkContainer" onClick={() => { history.push('./TONAR') }}>
                            <img src={jp} className="benchmarkIcon" width="25px" height="25px" />
                            <h5 className="card-title ml-1 riskHeading">TONAR</h5>
                        </div>
                    </div>
                    <div className="col-sm-1" />
                </div>

                <div className='extra-margin-top'></div>

                
                <div className="row text-center">
                    <div className="col-sm-6 col-sm-offset-3">
                        <div className="noticefontsize">
                            <br />
                            <br />
                            <span style={{ color: 'red', fontWeight: 'bold' }}>
                                Please note that this website will be decommissioned on 1st June 2025.
                                After this date the site will no longer be available. We recommend you consider alternative
                                sites that provide compounded rate calculations such as <u><a href="https://www.spglobal.com/market-intelligence/en/solutions/products/rfr-calculator">S&P Global RFR Calculator</a></u> or the <u><a href="https://www.ice.com/report/244">ICE RFR Portal</a></u>.
                            </span>
                        </div>
                    </div>
                </div>

                <div className='margin-bottom'></div>

            </div>
        </div>
    );
}

export default LandingView;




// WEBPACK FOOTER //
// ./src/components/LandingView.js